import { SVGProps } from 'react'

export const FolderSvg = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      version='1.1'
      viewBox='0 0 1024 1024'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path d='M897.695 190.565C878.615 119.24 839.87 62 769.13 62H254.87C184.175 62 143.36 121.265 126.305 190.565L62 415.565v417.87A128.97 128.97 0 0 0 190.565 962h642.87A128.97 128.97 0 0 0 962 833.435V415.565z m-707.13 0c11.07-35.145 28.935-64.305 64.305-64.305h514.26c35.37 0 53.235 29.115 64.305 64.305l64.305 225H126.305z m642.87 707.13H190.565a64.485 64.485 0 0 1-64.305-64.305V479.87h771.435v353.565a64.485 64.485 0 0 1-64.26 64.26z' />
      <path d='M801.26 640.565h-160.695a32.175 32.175 0 1 0 0 64.305h160.695a32.175 32.175 0 0 0 0-64.305z m-0.99 136.62H479.825a32.175 32.175 0 1 0 0 64.305h320.445a32.175 32.175 0 1 0 0-64.305z' />
    </svg>
  )
}
